import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-admin-footer',
  standalone: false,
  templateUrl: './admin-footer.html',
  styleUrl: './admin-footer.css',
})
export class AdminFooter {
  readonly version = environment.site_version;
  readonly year = new Date().getFullYear();
}
